import { createContext } from 'react';

export interface WebTagPermissionsContextType {
  permissions: string[];
  isLoading: boolean;
  hasPermission: (tag: string) => boolean;
}

export const WebTagPermissionsContext = createContext<WebTagPermissionsContextType>({
  permissions: [],
  isLoading: true,
  hasPermission: () => false,
});
